import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-comment-form-modal',
  templateUrl: './comment-form-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class CommentFormModalComponent {
  @Input() title: string;
  @Input() comment: string;
  @Input() isEnabled: boolean;
  @Output() readonly responseChanged = new EventEmitter();

  emitTrue(): void {
    this.responseChanged.emit(this.comment || undefined);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}
